import type { AccountRole } from '@timelyapp/integration-cloud-api-spec';

/**
 * Determine if user's `role` has elevated permissions (can do most "admin things")
 * @note `admin` is missing here, but should be introduced asap.
 * @link https://linear.app/timelyapp/issue/TT-1786/proper-user-level-controls-around-integrations-account-userrole
 */

export const checkIsAccountRoleElevatedStatus = (role: string | AccountRole): boolean => {
  return ['owner', 'admin'].includes(role);
};
